export enum DeliveryStatusForUser {
  UNKNOWN = 'UNKNOWN',
  DELIVERED = 'DELIVERED',
  ERROR = 'ERROR',
}
